const tabsInit = (el: HTMLElement) => {
  const switches: NodeListOf<HTMLElement> = el.querySelectorAll('.tabs__switch');
  const firstSwitch: HTMLElement = el.querySelector('.tabs__switch:first-child');
  const switchBackground: HTMLElement = el.querySelector('.tabs__switcher-bg');
  // const tabs = el.querySelectorAll('.tabs__tab');

  switchBackground.style.left = `${firstSwitch.offsetLeft}px`;
  switchBackground.style.width = `${firstSwitch.offsetWidth}px`;

  switchBackground.style.height = `${firstSwitch.offsetHeight}px`;
  switchBackground.style.top = `${firstSwitch.offsetTop}px`;

  switches.forEach((element: HTMLElement) => {
    element.addEventListener('click', (e) => {
      e.preventDefault();

      const index = element.dataset.tab;
      const makeActive = el.querySelector(`.tabs__tab[data-tab="${index}"]`);
      const currentActive = el.querySelector('.tabs__tab.active');

      switchBackground.style.left = `${element.offsetLeft}px`;
      switchBackground.style.width = `${element.offsetWidth}px`;

      switchBackground.style.height = `${element.offsetHeight}px`;
      switchBackground.style.top = `${element.offsetTop}px`;

      currentActive.classList.remove('active');
      makeActive.classList.add('active');
    });
  });
};

export default tabsInit;
